var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-slider',_vm._g(_vm._b({},'vue-slider',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }